// extracted by mini-css-extract-plugin
export default {"ActionButton":"QrCodeCreateForm_ActionButton__SiCxo","ActionButtons":"QrCodeCreateForm_ActionButtons__310+f"};